export default __webpack_public_path__ + "static/media/Apple-Books.caee04a9.png";